import {
  SENDING_CONFIRMATION_EMAIL,
  SENDING_CONFIRMATION_EMAIL_FAILURE,
  SENDING_CONFIRMATION_EMAIL_SUCCESSFUL
} from "../../constants";

let initialState = {
  errorSendingEmail: false,
  isSendingEmail: false,
  emailSentSuccessfully: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SENDING_CONFIRMATION_EMAIL: {
      return {
        ...state,
        isSendingEmail: true
      };
    }
    case SENDING_CONFIRMATION_EMAIL_FAILURE: {
      return {
        ...state,
        isSendingEmail: false,
        errorSendingEmail: action.payload
      };
    }
    case SENDING_CONFIRMATION_EMAIL_SUCCESSFUL: {
      return {
        ...state,
        isSendingEmail: false,
        emailSentSuccessfully: true
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/ReservationsPage/reducer.js